import { withStyles } from '@material-ui/core';

import ChartBar from './component';
import styles from './styles';

export default withStyles(styles)(ChartBar);
